import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import App from './App';
import { Provider } from 'react-redux';
import store from './redux';
import './style/base.css'

const history = createBrowserHistory();


ReactDOM.render(
    <Provider store={store}> 
    <Router history={history} >
        <Switch>
            
        <Route path="/" component={App} />
        </Switch>
    </Router>
    </Provider>,
    document.getElementById('root')
);
